// Cross-section state: the completed wizard walk that the contact form
// attaches when the visitor asks for quotes.
import { ref } from 'vue'
import type { ContactContext } from '@/shared/api/types'

export const contactContext = ref<ContactContext | undefined>(undefined)

export function scrollTo(id: string) {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })
}
